/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const newRouteSlice = createSlice({
    name: 'newRouteList',
    initialState: [],
    reducers: {
        /** Reset new route state. */
        initNewRoute: (state, action) => {
            return [];
        },
        /** Allocate new route state. */
        setNewRoute: (state, action) => {
            return action.payload;
        },
        /** Filter new route state by route id. */
        deleteNewRoute: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((item) => item.id !== idToDelete);
        },
    },
});

export const { initNewRoute, setNewRoute, deleteNewRoute } = newRouteSlice.actions;
export default newRouteSlice.reducer;
